import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-100 via-fuchsia-50 to-sky-100">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors font-medium mb-8"
          data-testid="back-home-button"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </button>

        <div className="bg-white/80 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/50 shadow-2xl">
          <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-8 tracking-tight">
            {t('privacy.title')}
          </h1>

          <div className="space-y-8 text-base md:text-lg text-slate-600 leading-relaxed">
            <p>{t('privacy.intro')}</p>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                {t('privacy.dataCollection')}
              </h2>
              <p className="mb-4">{t('privacy.dataCollectionText')}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.emailInfo')}</li>
                <li>{t('privacy.countryInfo')}</li>
                <li>{t('privacy.currencyInfo')}</li>
                <li>{t('privacy.ipInfo')}</li>
                <li>{t('privacy.cityInfo')}</li>
                <li>{t('privacy.postalInfo')}</li>
                <li>{t('privacy.phoneInfo')}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                {t('privacy.dataUsage')}
              </h2>
              <p className="mb-4">{t('privacy.dataUsageText')}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.deliverResults')}</li>
                <li>{t('privacy.processPayments')}</li>
                <li>{t('privacy.fraudPrevention')}</li>
                <li>{t('privacy.improveService')}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                {t('privacy.dataSecurity')}
              </h2>
              <p>{t('privacy.dataSecurityText')}</p>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                {t('privacy.dataRetention')}
              </h2>
              <p>{t('privacy.dataRetentionText')}</p>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                {t('privacy.contact')}
              </h2>
              <p>{t('privacy.contactText')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}